var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-generator"},[_c('FormGenerator',{attrs:{"data":_vm.form,"isLoading":_vm.isLoading},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }